module.exports = require("@splunk/react-ui/Heading");